import { ScrollArea } from "../ui/scroll-area";
import { Footer } from "./footer";
import { Navbar } from "./navbar";

export function ContentLayout({ title, children }) {
  return (
    <div>
      <Navbar title={title} />
      <div className="pt-5 px-4 sm:px-8 h-[calc(100vh-98px)] overflow-y-auto custom-scroll scrollbar-thumb">
        {children}
      </div>
      <Footer />
    </div>
  );
}
